__turbopack_context__.v({
  "absolute-skeleton": "Cover-module-sass-module__l-nPFa__absolute-skeleton",
  "aside": "Cover-module-sass-module__l-nPFa__aside",
  "aside-container": "Cover-module-sass-module__l-nPFa__aside-container",
  "aside-inner": "Cover-module-sass-module__l-nPFa__aside-inner",
  "aside-skeleton": "Cover-module-sass-module__l-nPFa__aside-skeleton",
  "aside-wrapper": "Cover-module-sass-module__l-nPFa__aside-wrapper",
  "aside-wrapper-skeleton": "Cover-module-sass-module__l-nPFa__aside-wrapper-skeleton",
  "container": "Cover-module-sass-module__l-nPFa__container",
  "content": "Cover-module-sass-module__l-nPFa__content",
  "img": "Cover-module-sass-module__l-nPFa__img",
  "line-skeleton--1": "Cover-module-sass-module__l-nPFa__line-skeleton--1",
  "line-skeleton--2": "Cover-module-sass-module__l-nPFa__line-skeleton--2",
  "line-skeleton--3": "Cover-module-sass-module__l-nPFa__line-skeleton--3",
  "line-skeleton--4": "Cover-module-sass-module__l-nPFa__line-skeleton--4",
  "main": "Cover-module-sass-module__l-nPFa__main",
  "main-blur": "Cover-module-sass-module__l-nPFa__main-blur",
  "main-blur-wrapper": "Cover-module-sass-module__l-nPFa__main-blur-wrapper",
  "main-skeleton": "Cover-module-sass-module__l-nPFa__main-skeleton",
  "rect-skeleton": "Cover-module-sass-module__l-nPFa__rect-skeleton",
  "spin": "Cover-module-sass-module__l-nPFa__spin",
  "svg-skeleton": "Cover-module-sass-module__l-nPFa__svg-skeleton",
});
